import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';

export interface AdminLinkProps {
  className?: string;
}

export function AdminLink({ className = "" }: AdminLinkProps = {}) {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) return;

      try {
        const { data, error } = await supabase.rpc('check_admin_role', { 
          user_id: user.id,
          required_role: 'admin'
        });
        if (error) throw error;
        setIsAdmin(data || false);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  if (!isAdmin) return null;

  return (
    <Link
      to="/admin"
      className={`flex items-center space-x-2 px-3 py-2 text-sm font-medium text-secondary hover:text-secondary-dark bg-secondary-light hover:bg-secondary-light/80 rounded-lg border border-secondary transition-colors ${className}`}
    >
      <Shield className="w-4 h-4" />
      <span>Admin Panel</span>
    </Link>
  );
}